module.exports = __webpack_public_path__ + "static/media/img158.c2ff8df9.jpg";